import React from 'react';
import axios from 'axios';
import {Route} from 'react-router-dom';
import {Redirect} from 'react-router';
import {Context} from "../configcontext/ConfigContext";
import 'bootstrap/dist/css/bootstrap.min.css';
import './AdminAccountCount.css';

class AdminAccountCount extends React.Component{

	static contextType = Context;

	constructor(props) {
		super(props);
			this.state = {
		    loading: true,
		    numAccounts: 0,
		    selected: false,
		    moduleBoolText: "",
		    modalBody: "",
		    modalHeader: "",
		    show: false
		}
		this.showModal = this.showModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.updateModuleColor = this.updateModuleColor.bind(this);
	}

	updateModuleColor(e){
		var moduleBoolText = e.target.id;
		this.props.updateModules(moduleBoolText);
		if(this.state.selected){
			this.setState({selected: false});
		}else{
			this.setState({selected: true});
		}
	}

  	componentDidMount() {
	  	this.setState({loading: false, moduleBoolText: this.props.moduleBoolText});
	  	let value = this.context;
	    axios.post('https://www.arutility.com/api/v4/accounts/adminGetCount.php',{},{headers: {Authorization: 'Bearer ' + value.jwt}})
		.then(res => {
		    var numAccounts = res.data["numAccounts"];
		    this.setState({ numAccounts: numAccounts, loading: false });
		}).catch(error => {
	        if (error.response) {
	        	this.setState({loading: false});
		    } else if (error.request) {
		      // The request was made but no response was received
		        this.setState({loading: false});
		    } else {
		      // Something happened in setting up the request that triggered an Error
		        this.setState({loading: false});
		    }
	    });
  	}

  	componentDidUpdate(){
  		if(this.props.selected != this.state.selected){
  			this.setState({selected: this.props.selected});
  		}
  	}

  	showModal(){
    	this.setState({show: true});
  	}

  	closeModal(){
    	this.setState({show: false});
  	}

  	render(){
	  	let value = this.context;
	  	if(value.jwt == ""){
	      return(
	        <Route>
	          <Redirect to="/login" />
	        </Route>
	      );
	    }else{
	    	if(value.userPermissions.includes("user:super")){
			    return (
			   		<div className={this.state.selected ? "adminModuleWrapperSelected" : "adminModuleWrapper" } id={this.state.moduleBoolText} onClick={this.updateModuleColor}>
			   			<div className="adminModuleLarge" id={this.state.moduleBoolText} onClick={this.updateModuleColor}>
			   				{this.state.numAccounts}
			   			</div>
			   			<div className="adminModuleFooter" id={this.state.moduleBoolText} onClick={this.updateModuleColor}>
			   				# of Accounts
			   			</div>
			   		</div>
			    );
			}else{
		       return null;
		    }
		}
  	}
}

export default AdminAccountCount;